/* =========================================================
   NEO GREENS - MAIN JS
========================================================= */

(function () {

  "use strict";


  /* =========================================================
     HELPER
  ========================================================= */

  function ready(callback) {

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
    } else {
      callback();
    }

  }


  /* =========================================================
     CHECK SWIPER
  ========================================================= */

  function swiperAvailable() {
    return typeof Swiper !== "undefined";
  }


  /* =========================================================
     VARIANT IMAGE FILTER
  ========================================================= */

  function updateVariantImages(variant) {

    if (!variant || !variant.option1) return;

    const size = variant.option1
      .toString()
      .toLowerCase()
      .trim();

    document.querySelectorAll(".product__media-item").forEach(function (media) {

      const image = media.querySelector("img");

      if (!image) return;

      const alt = (image.alt || "")
        .toLowerCase()
        .trim();

      if (alt === size) {
        media.classList.remove("hide-media");
      } else {
        media.classList.add("hide-media");
      }

    });

  }


  document.addEventListener("variant:change", function (event) {

    if (!event.detail) return;

    updateVariantImages(event.detail.variant);

  });


  /* =========================================================
     BACK TO TOP
  ========================================================= */

  function initBackToTop() {

    const backToTop = document.getElementById("backToTop");

    if (!backToTop) return;

    function toggleBackToTop() {

      if (window.scrollY > 300) {
        backToTop.classList.add("active");
      } else {
        backToTop.classList.remove("active");
      }

    }

    window.addEventListener("scroll", toggleBackToTop, {
      passive: true
    });

    backToTop.addEventListener("click", function () {

      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });

    });

    toggleBackToTop();

  }


  /* =========================================================
     HERO SWIPER
  ========================================================= */

  function initHeroSwiper() {

    if (!swiperAvailable()) return;

    document.querySelectorAll(".heroSwiper").forEach(function (slider) {

      if (slider.swiper) return;

      new Swiper(slider, {

        loop: true,

        speed: 1000,

        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },

        navigation: {
          nextEl: slider.querySelector(".swiper-button-next"),
          prevEl: slider.querySelector(".swiper-button-prev")
        }

      });

    });

  }


  /* =========================================================
     SCIENCE SWIPER
  ========================================================= */

  function initScienceSwiper() {

    if (!swiperAvailable()) return;

    document.querySelectorAll(".scienceSwiper").forEach(function (slider) {

      if (slider.swiper) return;

      new Swiper(slider, {

        loop: true,

        spaceBetween: 30,

        speed: 1000,

        navigation: {
          nextEl: slider.querySelector(".science-next"),
          prevEl: slider.querySelector(".science-prev")
        },

        breakpoints: {

          0: {
            slidesPerView: 1
          },

          768: {
            slidesPerView: 2
          },

          1200: {
            slidesPerView: 3
          }

        }

      });

    });

  }


  /* =========================================================
     TIMELINE SWIPER
  ========================================================= */

  function initTimelineSwiper() {

    if (!swiperAvailable()) return;

    document.querySelectorAll(".timeline-swiper").forEach(function (slider) {

      if (slider.swiper) return;

      const container = slider.closest(".timeline-container");

      let containerLeft = 0;

      if (container) {
        containerLeft = container.getBoundingClientRect().left;
      }

      new Swiper(slider, {

        slidesPerView: "auto",

        spaceBetween: 24,

        grabCursor: true,

        loop: false,

        slidesOffsetBefore: containerLeft,

        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        }

      });

    });

  }


  /* =========================================================
     RESULTS SWIPER
  ========================================================= */

  function initResultsSwiper() {

    if (!swiperAvailable()) return;

    document.querySelectorAll(".neo-results-swiper").forEach(function (slider) {

      if (slider.swiper) return;

      new Swiper(slider, {

        slidesPerView: 4,

        spaceBetween: 20,

        loop: true,

        speed: 1000,

        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },

        breakpoints: {

          0: {
            slidesPerView: 1
          },

          768: {
            slidesPerView: 2
          },

          992: {
            slidesPerView: 3
          },

          1200: {
            slidesPerView: 4
          }

        }

      });

    });

  }


  /* =========================================================
     NUTRITION SLIDER
  ========================================================= */

  function initNutritionSlider() {

    if (!swiperAvailable()) return;

    document.querySelectorAll(".neoNutritionSlider").forEach(function (slider) {

      if (slider.swiper) return;

      const wrapper = slider.querySelector(".swiper-wrapper");

      if (!wrapper) return;

      /*
       * Only duplicate once.
       */
      if (wrapper.dataset.duplicated === "true") {
        return;
      }

      const originalSlides = Array.from(wrapper.children);

      if (!originalSlides.length) return;

      /*
       * Duplicate slides for continuous movement.
       */
      for (let i = 0; i < 4; i++) {

        originalSlides.forEach(function (slide) {

          wrapper.appendChild(
            slide.cloneNode(true)
          );

        });

      }

      wrapper.dataset.duplicated = "true";


      new Swiper(slider, {

        slidesPerView: 4,

        slidesPerGroup: 1,

        spaceBetween: 0,

        loop: false,

        speed: 5000,

        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        },

        allowTouchMove: true,

        breakpoints: {

          320: {

            slidesPerView: 2,

            slidesPerGroup: 1,

            spaceBetween: 16

          },

          768: {

            slidesPerView: 4,

            slidesPerGroup: 1,

            spaceBetween: 24

          }

        }

      });

    });

  }


  /* =========================================================
     LOGO SLIDER
  ========================================================= */

  function initLogoSlider() {

    if (!swiperAvailable()) return;

    document.querySelectorAll(".neoLogoSlider").forEach(function (slider) {

      if (slider.swiper) return;

      new Swiper(slider, {

        slidesPerView: 5,

        spaceBetween: 40,

        loop: true,

        speed: 3000,

        autoplay: {

          delay: 0,

          disableOnInteraction: false

        },

        breakpoints: {

          320: {

            slidesPerView: 3,

            spaceBetween: 20

          },

          768: {

            slidesPerView: 4,

            spaceBetween: 30

          },

          1200: {

            slidesPerView: 5,

            spaceBetween: 40

          }

        }

      });

    });

  }


  /* =========================================================
     ABOUT NG SLIDER
  ========================================================= */

  function initAboutSwiper() {

    if (!swiperAvailable()) return;

    document.querySelectorAll(".aboutNgSwiper").forEach(function (slider) {

      if (slider.swiper) return;

      const pagination = slider.querySelector(".swiper-pagination");

      new Swiper(slider, {

        loop: true,

        speed: 800,

        autoplay: {

          delay: 10000,

          disableOnInteraction: false

        },

        pagination: pagination ? {

          el: pagination,

          clickable: true

        } : undefined

      });

    });

  }


  /* =========================================================
     BATCH SWIPER
  ========================================================= */

  function initBatchSwiper() {

    if (!swiperAvailable()) return;

    document.querySelectorAll(".batchSwiper").forEach(function (slider) {

      if (slider.swiper) return;

      new Swiper(slider, {

        slidesPerView: 1.2,

        spaceBetween: 20,

        loop: true,

        speed: 1000,

        autoplay: {

          delay: 2500,

          disableOnInteraction: false

        },

        breakpoints: {

          576: {

            slidesPerView: 1.5

          },

          768: {

            slidesPerView: 2

          },

          992: {

            slidesPerView: 3

          }

        }

      });

    });

  }


  /* =========================================================
     NG TIMELINE SWIPER
  ========================================================= */

  function initNgTimelineSwiper() {

    if (!swiperAvailable()) return;

    document.querySelectorAll(".ngTimelineSwiper").forEach(function (slider) {

      if (slider.swiper) return;

      new Swiper(slider, {

        slidesPerView: 1.2,

        spaceBetween: 20,

        loop: true,

        navigation: {

          nextEl: ".ng-timeline-next",

          prevEl: ".ng-timeline-prev"

        },

        breakpoints: {

          576: {

            slidesPerView: 2

          },

          768: {

            slidesPerView: 3

          },

          1200: {

            slidesPerView: 4

          }

        }

      });

    });

  }


  /* =========================================================
     REVIEWS SWIPER
  ========================================================= */

  function initReviewSwiper() {

    if (!swiperAvailable()) return;

    document.querySelectorAll(".ngReviewSwiper").forEach(function (slider) {

      if (slider.swiper) return;

      new Swiper(slider, {

        slidesPerView: 1.2,

        spaceBetween: 20,

        loop: true,

        breakpoints: {

          576: {

            slidesPerView: 2

          },

          768: {

            slidesPerView: 3

          },

          1200: {

            slidesPerView: 4

          }

        }

      });

    });

  }


  /* =========================================================
     INGREDIENT CARDS
  ========================================================= */

  function initIngredientCards() {

    document.querySelectorAll(".ingredient-card").forEach(function (card) {

      if (card.dataset.initialized === "true") return;

      card.dataset.initialized = "true";

      card.addEventListener("click", function () {

        const parent = card.closest(".ingredients-wrapper");

        if (!parent) return;

        parent.querySelectorAll(".ingredient-card").forEach(function (item) {

          item.classList.remove("active");

        });

        card.classList.add("active");

      });

    });

  }


  /* =========================================================
     TABS
  ========================================================= */

  function initTabs() {

    const buttons = document.querySelectorAll(".ng-tab-btn");

    const contents = document.querySelectorAll(".ng-tab-content");

    if (!buttons.length) return;

    buttons.forEach(function (button) {

      if (button.dataset.initialized === "true") return;

      button.dataset.initialized = "true";

      button.addEventListener("click", function () {

        const tab = button.dataset.tab;

        buttons.forEach(function (btn) {

          btn.classList.remove("active");

        });

        contents.forEach(function (content) {

          content.classList.remove("active");

        });

        button.classList.add("active");

        const activeTab = document.getElementById(tab);

        if (activeTab) {

          activeTab.classList.add("active");

        }

      });

    });

  }


  /* =========================================================
     RESEARCH TABS
  ========================================================= */

  function initResearchTabs() {

    const buttons = document.querySelectorAll(".research-tab-btn");

    const contents = document.querySelectorAll(".research-tab-content");

    if (!buttons.length) return;

    buttons.forEach(function (button) {

      if (button.dataset.initialized === "true") return;

      button.dataset.initialized = "true";

      button.addEventListener("click", function () {

        buttons.forEach(function (btn) {

          btn.classList.remove("active");

        });

        contents.forEach(function (content) {

          content.classList.remove("active");

        });

        button.classList.add("active");

        const target = document.getElementById(
          button.dataset.tab
        );

        if (target) {

          target.classList.add("active");

        }

      });

    });

  }


  /* =========================================================
     INGREDIENT GALLERY TABS
  ========================================================= */

  function initIngredientGalleryTabs() {

    const buttons = document.querySelectorAll(
      ".ingredient-gallery-tab-btn"
    );

    const groups = document.querySelectorAll(
      ".ingredient-category-block"
    );

    if (!buttons.length) return;

    buttons.forEach(function (button) {

      if (button.dataset.initialized === "true") return;

      button.dataset.initialized = "true";

      button.addEventListener("click", function () {

        buttons.forEach(function (btn) {

          btn.classList.remove("active");

        });

        button.classList.add("active");

        const filter = button.dataset.filter;

        groups.forEach(function (group) {

          const category = group.dataset.categoryBlock;

          if (
            filter === "all" ||
            filter === category
          ) {

            group.style.display = "block";

          } else {

            group.style.display = "none";

          }

        });

      });

    });

  }


  /* =========================================================
     INGREDIENT STICKY BAR
  ========================================================= */

  function initIngredientStickyBar() {

    const stickyBar = document.querySelector(
      ".ingredient-tabs-gallery-section .ingredient-tabs-gallery-buttons"
    );

    if (!stickyBar) return;

    function checkSticky() {

      const rect = stickyBar.getBoundingClientRect();

      if (rect.top <= 20) {

        stickyBar.classList.add("sticky-active");

      } else {

        stickyBar.classList.remove("sticky-active");

      }

    }

    window.addEventListener("scroll", checkSticky, {
      passive: true
    });

    checkSticky();

  }


  /* =========================================================
     SCIENCE LEAF ANIMATION
  ========================================================= */

  function initLeafAnimation() {

    const leaf = document.querySelector(".ng-leaf-animate");

    if (!leaf) return;

    if (!("IntersectionObserver" in window)) {

      leaf.classList.add("is-visible");

      return;

    }

    const observer = new IntersectionObserver(

      function (entries) {

        entries.forEach(function (entry) {

          if (entry.isIntersecting) {

            entry.target.classList.add("is-visible");

            observer.unobserve(entry.target);

          }

        });

      },

      {
        threshold: 0.4
      }

    );

    observer.observe(leaf);

  }


  /* =========================================================
     ABSORPTION BAR ANIMATION
  ========================================================= */

  function initAbsorptionBars() {

    const section = document.querySelector(
      ".absorption-section"
    );

    if (!section) return;

    const cards = section.querySelectorAll(
      ".bar-card"
    );

    if (!cards.length) return;

    function startBarAnimation() {

      cards.forEach(function (card) {

        const percentText =
          card.querySelector(".bar-percent");

        const fillBar =
          card.querySelector(".bar-fill");

        if (!percentText || !fillBar) return;

        const target = parseInt(
          percentText.getAttribute("data-target"),
          10
        );

        if (isNaN(target)) return;

        fillBar.style.height = "0%";

        percentText.innerHTML = "0%";

        card.classList.remove("active");

        setTimeout(function () {

          fillBar.style.height =
            target + "%";

          let count = 0;

          const counter = setInterval(function () {

            if (count >= target) {

              clearInterval(counter);

              card.classList.add("active");

            } else {

              count++;

              percentText.innerHTML =
                count + "%";

            }

          }, 20);

        }, 200);

      });

    }


    if (!("IntersectionObserver" in window)) {

      startBarAnimation();

      return;

    }


    const observer = new IntersectionObserver(

      function (entries) {

        entries.forEach(function (entry) {

          if (entry.isIntersecting) {

            startBarAnimation();

            observer.unobserve(entry.target);

          }

        });

      },

      {
        threshold: 0.5
      }

    );

    observer.observe(section);

  }


  /* =========================================================
     ROOT VIDEO
  ========================================================= */

  function initRootVideos() {

    document.querySelectorAll(".root-video").forEach(function (section) {

      if (section.dataset.initialized === "true") return;

      section.dataset.initialized = "true";

      const playBtn =
        section.querySelector(".play-button");

      const thumbnail =
        section.querySelector(".video-thumbnail");

      const player =
        section.querySelector(".video-player");

      const iframe =
        section.querySelector("iframe");

      if (
        !playBtn ||
        !thumbnail ||
        !player ||
        !iframe
      ) {
        return;
      }


      playBtn.addEventListener("click", function () {

        const videoUrl =
          this.dataset.video;

        if (!videoUrl) return;

        iframe.src =
          videoUrl +
          (videoUrl.includes("?") ? "&" : "?") +
          "autoplay=1";

        thumbnail.classList.add("d-none");

        player.classList.remove("d-none");

      });


      if ("IntersectionObserver" in window) {

        const observer =
          new IntersectionObserver(

            function (entries) {

              entries.forEach(function (entry) {

                if (
                  !entry.isIntersecting &&
                  iframe.src
                ) {

                  iframe.src = "";

                  player.classList.add("d-none");

                  thumbnail.classList.remove("d-none");

                }

              });

            },

            {
              threshold: 0.3
            }

          );

        observer.observe(section);

      }

    });

  }


  /* =========================================================
     SOCIAL LINKS
  ========================================================= */

  function initSocialLinks() {

    document.querySelectorAll(
      ".list-social__link"
    ).forEach(function (link) {

      link.setAttribute(
        "target",
        "_blank"
      );

      link.setAttribute(
        "rel",
        "noopener noreferrer"
      );

    });

  }


  /* =========================================================
     INITIALIZE EVERYTHING
  ========================================================= */

  function initializeAll() {

    initBackToTop();

    initHeroSwiper();

    initScienceSwiper();

    initTimelineSwiper();

    initResultsSwiper();

    initNutritionSlider();

    initLogoSlider();

    initAboutSwiper();

    initBatchSwiper();

    initNgTimelineSwiper();

    initReviewSwiper();

    initIngredientCards();

    initTabs();

    initResearchTabs();

    initIngredientGalleryTabs();

    initIngredientStickyBar();

    initLeafAnimation();

    initAbsorptionBars();

    initRootVideos();

    initSocialLinks();

  }


  /* =========================================================
     DOM READY
  ========================================================= */

  ready(function () {

    initializeAll();

  });


  /* =========================================================
     SHOPIFY THEME EDITOR
  ========================================================= */

  document.addEventListener(
    "shopify:section:load",
    function () {

      setTimeout(function () {

        initializeAll();

      }, 100);

    }
  );


  document.addEventListener(
    "shopify:section:reorder",
    function () {

      setTimeout(function () {

        initializeAll();

      }, 100);

    }
  );


  document.addEventListener(
    "shopify:section:select",
    function () {

      setTimeout(function () {

        initializeAll();

      }, 100);

    }
  );


  document.addEventListener(
    "shopify:section:deselect",
    function () {

      setTimeout(function () {

        initializeAll();

      }, 100);

    }
  );


})();